<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M15.5,0a.75.75,0,0,0-.75.75V23a1,1,0,0,0,2,0V15a.5.5,0,0,1,.5-.5H19a1.243,1.243,0,0,0,1.25-1.25v-.007C20.186,6.055,17.832,0,15.5,0Z"/><path d="M10.75,0a1,1,0,0,0-1,1V6a1.993,1.993,0,0,1-.571,1.4.251.251,0,0,1-.429-.175V1a1,1,0,0,0-2,0V7.223a.251.251,0,0,1-.429.175A1.993,1.993,0,0,1,5.75,6V1a1,1,0,0,0-2,0V6A4.009,4.009,0,0,0,6.417,9.772a.5.5,0,0,1,.333.471V23a1,1,0,0,0,2,0V10.243a.5.5,0,0,1,.333-.471A4.009,4.009,0,0,0,11.75,6V1A1,1,0,0,0,10.75,0Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'restaurant-fork-knife',
    },
    name: {
      type: String,
      required: false,
      default: 'RestaurantForkKnife',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>